export const LOCALE_COOKIE = {
    name: 'locale',
    expires: 365,
    path: '/'
}

export const TEST_RESULT_MAP = {
    'failed': '실패',
    'error': '실행 에러',
    'passed': '성공',
    'skipped': '확인 필요'
}
